import styled from "styled-components";
import { Text } from "./Text";

export const AppName = styled(Text.Heading5).attrs({ weight: 600 })`
  color: ${({ theme }) => theme.color.additional.dark.value};
  margin: 8px 0;
`;
